import classNames from 'classnames'
import { Link } from 'gatsby'
import * as React from 'react'
import { AiOutlineDownload, AiOutlineLink } from 'react-icons/ai'
import BtnFullView from '../btn-full-view/btn-full-view.component'
import styleClasses from './widget-tile.module.scss'

export type WidgetTileProps = {
  tile?: GatsbyTypes.Maybe<GatsbyTypes.tileFragment>
}

export const TileType = {
  Do: 'Guideline-Do',
  Dont: 'Guideline-Dont',
  Link: 'Quick-Link',
  List: 'List-View',
  Img: 'Image-Only',
  Caption: 'Image-Caption',
  Vertical: 'Standard-Vertical',
}

const TileContainer: React.FC<{ tile: GatsbyTypes.tileFragment }> = ({ tile, children }) => {
  const { navigationLink, downloadLink, variant } = tile
  const className = classNames(styleClasses.card, {
    [styleClasses.variantGuidelineDo]: variant === TileType.Do,
    [styleClasses.variantGuidelineDont]: variant === TileType.Dont,
    [styleClasses.variantQuickLink]: variant === TileType.Link,
    [styleClasses.variantListView]: variant === TileType.List,
    [styleClasses.variantImageOnly]: variant === TileType.Img,
    [styleClasses.variantImageCaption]: variant === TileType.Caption,
    [styleClasses.variantVertical]: variant === TileType.Vertical,
  })
  if (navigationLink) {
    const isExternal = navigationLink.startsWith('http')
    if (!isExternal)
      return (
        <Link to={navigationLink} className={className}>
          {children}
          <span className={styleClasses.cardIcon}>
            <AiOutlineLink />
          </span>
        </Link>
      )
    return (
      <a href={navigationLink} target="_blank" rel="noopener noreferrer" className={className}>
        {children}
        <span className={styleClasses.cardIcon}>
          <AiOutlineLink />
        </span>
      </a>
    )
  }
  if (downloadLink)
    return (
      <a href={downloadLink} download={tile.title} className={className}>
        {children}
        <span className={styleClasses.cardIcon}>
          <AiOutlineDownload />
        </span>
      </a>
    )
  return <div className={className}>{children}</div>
}

const WidgetTile: React.FC<WidgetTileProps> = ({ tile }) => {
  if (!tile) return null
  const { image, title, description, variant, imageFit } = tile
  const showTitle = variant !== TileType.Img
  const showDescription = variant !== TileType.Img && variant !== TileType.Caption
  const img = image?.file?.url && (
    <img
      src={image.file.url}
      alt={image?.title || undefined}
      className={classNames(styleClasses.img, {
        [styleClasses.contain]: imageFit === 'Contain',
        [styleClasses.none]: imageFit === 'None',
      })}
    />
  )
  return (
    <TileContainer tile={tile}>
      {img ? (
        <div className={styleClasses.imgContainer}>
          {img}
          {(variant === TileType.Do || variant === TileType.Dont) && (
            <BtnFullView className={styleClasses.containedIcon}>
              {image?.file?.url && (
                <img
                  src={image.file?.url || undefined}
                  style={{ display: 'block', maxWidth: '100%', margin: 'auto' }}
                  alt={image?.title || undefined}
                />
              )}
            </BtnFullView>
          )}
        </div>
      ) : null}
      {title && showTitle ? <h5 className={styleClasses.title}>{title}</h5> : null}
      {description?.description && showDescription ? <p className={styleClasses.description}>{description.description}</p> : null}
    </TileContainer>
  )
}

export default WidgetTile
